import { Grid, Typography } from '@mui/material';
import styles from './styles';
import Div from '../../../../../shared/ui/Div';
import React, { FC } from 'react';

const ManageTeacherColumns: FC = () => {
  return (
    <Div sx={styles.container}>
      <Grid container>
        <Grid xs={12} sm={3} item sx={styles.column}>
          <Typography sx={styles.columnTitle}>Teacher Name</Typography>
        </Grid>
        <Grid xs={12} sm={4} item sx={styles.column}>
          <Typography sx={styles.columnTitle}>Email</Typography>
        </Grid>
        <Grid xs={12} sm={5} item sx={styles.column}>
          <Typography sx={styles.columnTitle}>Type</Typography>
        </Grid>
      </Grid>
    </Div>
  );
};

export default ManageTeacherColumns;